import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiCommand, FiLayers, FiUsers, FiLogOut } from 'react-icons/fi';

const navItems = [
  { path: '/superadmin/dashboard', label: 'Command Center', icon: <FiCommand /> },
  { path: '/superadmin/portals', label: 'Workspaces', icon: <FiLayers /> },
  { path: '/superadmin/users', label: 'People', icon: <FiUsers /> },
];

export default function SuperAdminLayout() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/superadmin/auth/session').then(({ data }) => {
      if (data.loggedIn) setAdmin(data.admin);
      else navigate('/superadmin/login');
    }).catch(() => navigate('/superadmin/login'))
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = async () => {
    await api.post('/superadmin/auth/logout');
    toast.success('Logged out');
    navigate('/superadmin/login');
  };

  if (loading) return <div className="loading-spinner" style={{ height: '100vh' }}><div className="spinner" /></div>;
  if (!admin) return null;

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/Affixcenter_OG_Fulllogo.png" alt="Logo" className="sidebar-logo-img" style={{ width: 38, height: 38, borderRadius: 8, objectFit: 'contain' , background:'white'}} />
          <div className="sidebar-logo-text">
            <h1>Affix Digital Setu</h1>
            <span>Super Admin</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          <div className="sidebar-section">
            <div className="sidebar-section-title">Management</div>
            {navItems.map(item => (
              <NavLink key={item.path} to={item.path} data-tooltip={item.label}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                {item.icon}
                <span className="link-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        </nav>
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="sidebar-link" data-tooltip="Logout" style={{ width: '100%', border: 'none', background: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
            <FiLogOut />
            <span className="link-label">Logout</span>
          </button>
        </div>
      </aside>

      <header className="header">
        <h2 className="header-title">Super Admin Panel</h2>
        <div className="header-actions">
          <div className="header-user">
            <div className="header-avatar">SA</div>
            <div className="header-user-info">
              <span>{admin.username}</span>
              <small>Super Admin</small>
            </div>
          </div>
        </div>
      </header>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
